import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private tokenSubject = new BehaviorSubject<string | null>(null);
  public token$ = this.tokenSubject.asObservable();

  // Promise to track initialization completion
  private initPromise: Promise<void> | null = null;
  private isInitialized = false;

  constructor(private http:HttpClient) {
  }

  // This runs before app initialization (called by APP_INITIALIZER)
  initializeAuth(): Promise<void> {
    if (this.initPromise) {
      return this.initPromise;
    }

    this.initPromise = new Promise((resolve) => {
      try {
        const token = localStorage.getItem("customer_access_token");
        this.tokenSubject.next(token);
        this.isInitialized = true;
        resolve();
      } catch (error) {
        console.error('Error during auth initialization:', error);
        this.tokenSubject.next(null);
        this.isInitialized = true;
        resolve(); // Always resolve to not block app startup
      }
    });

    return this.initPromise;
  }

  // Method for interceptor to wait for initialization
  authInitialized(): Promise<void> {
    if (this.isInitialized) {
      return Promise.resolve();
    }
    return this.initPromise || this.initializeAuth();
  }

  // Get current token value (used in interceptor)
  getToken(): string | null {
    return this.tokenSubject.value;
  }

  // Update token (call this after login or token refresh)
  setToken(token: string): void {
    localStorage.setItem("customer_access_token", token);
    this.tokenSubject.next(token);
  }

  // Clear token (call this on logout)
  clearToken(): void {
    localStorage.removeItem("customer_access_token");
    this.tokenSubject.next(null);
  }

  // Check if user is authenticated
  isAuthenticated(): boolean {
    return !!this.tokenSubject.value;
  }

  HandleLogin(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authentication/v1/login`;
    return this.http.post<any>(apiURL, data);
  }

  ForgotPassword(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authentication/v1/forgot-password`;
    return this.http.post<any>(apiURL, data);
  }

  CheckLink(id: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authentication/v1/check-url-token/${id}`;
    return this.http.get<any>(apiURL);
  }

  ResetPassword(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authentication/v1/reset-password`;
    return this.http.post<any>(apiURL, data);
  }

  SignUp(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authentication/v1/client-signup`;
    return this.http.post<any>(apiURL, data);
  }

  loginUserInformation(): Observable<any> {
    const apiURL = `${environment.auth_url}/authorization/v1/login-user-information`;
    return this.http.get<any>(apiURL);
  }

  Logout(): Observable<any> {
    const apiURL = `${environment.auth_url}/authorization/v1/logout`;
    return this.http.post<any>(apiURL,'');
  }

  VerifyOtp(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authentication/v1/onboarding-check-otp`;
    return this.http.post<any>(apiURL, data);
  }

  GetOtp(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authentication/v1/onboarding-send-otp`;
    return this.http.post<any>(apiURL, data);
  }  

  CreateNewToken(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authentication/v1/refresh-token`;
    return this.http.post<any>(apiURL, data);
  }
  
  ChangePassword(data: any): Observable<any> {
    const apiURL = `${environment.auth_url}/authorization/v1/change-password`;
    return this.http.post<any>(apiURL, data);
  }
  
}
